import React from 'react';
import Validation from './Validation';
import ValidationCode from './ValidationCode';
import Header from './Header';
import './queries.css';
import CustomerDetails from './CustomerDetails';
import shelegDal from '../api/shelegDAL';
import Success from './Success';
import Video from './Video';
import Landing from './Landing';



class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: this.querystring('lang').length === 0 ? 'hebrew' : this.querystring('lang'),
            validationCode: '',
            screen: 'landing',
            callCode: this.querystring('area').length === 0 ? '0' : this.querystring('area'),
            callCodeName: '',
            sessionId: '',
            mobile: '',
            currentURL: window.location.href
        };
        
    }

    componentDidMount = async () => {
        await this.getSessionId();
        const publicIp = require('public-ip');

        (async () => {
            const response = await shelegDal.post(`GetCountryByIp`, { txt: await publicIp.v4() });
            if (response.data === 'Israel'){
                await this.changeLanguage('hebrew');
                await this.changeCallCode('972');
            }
            else{
            await this.changeLanguage('english');
            await this.changeCallCode('0');
            }
        })();
    };

    
    querystring(obj) {
        const result = [];
        let match;
        const re = new RegExp('(?:\\?|&)' + obj + '=(.*?)(?=&|$)', 'gi');
        while ((match = re.exec(document.location.search)) !== null) {
            result.push(match[1]);
        }
        return result;
    }

    getSessionId = async () => {
        const pkg = { slgcustCode: "aspjnudhhyebsh25kkhjhfystgs55kkxcvb", appId: "whatshub-registration", pwd: '', userNo: 1 };
        const response = await shelegDal.post(`/GetSessionIdX`, pkg);
        this.setState({ sessionId: response.data.sesId });
    };

    changeLanguage = async (language) => {
        // Languages: hebrew, english
        //console.log('language: ', language);
        if (language === 'hebrew' || language === 'english') {
            this.setState({ language: language });
        }
    };

    changeMobile = async (mobile) => {
        this.setState({ mobile: mobile });
    };

    changeScreen = async (screen) => {
        //console.log('change screen to ', screen)
        // Screens: landing, validation, validationCode, customerDetails, success
        if (screen === 'landing' || screen === 'validation' || screen === 'validationCode' || screen === 'customerDetails' || screen === 'success') {
            this.setState({ screen: screen });
        }
    };

    changeCallCode = async (callCode) => {
        this.setState({ callCode: callCode });
    };

    changeCallCodeName = async (callCodeName) => {
        this.setState({ callCodeName: callCodeName });
    };

    generateValidationCode = async () => {
        const min = 100000;
        const max = 999999;
        const code = Math.floor(min + Math.random() * (max - min));
        this.setState({ validationCode: code.toString() });
    };

    validateCode = (code) => {
        if (code !== '') {
            if (code === this.state.validationCode)
                return true
            else
                return false;
        }
        return false;
    };

    render() {
        if (this.state.screen === 'landing') return (
            <div className="col-xl-12">
                <Header
                    // State
                    language={this.state.language}
                    currentURL={this.state.currentURL}
                    //Variables
                    showHeading={false}
                    // Methods
                    changeLanguage={this.changeLanguage}
                />
                <Landing
                    // State
                    language={this.state.language}
                    // Methods
                    changeScreen={this.changeScreen}
                />
            </div>
        );
        else if (this.state.screen === 'validation') return (
            <div className="col-xl-12">
                <Header
                    // State
                    language={this.state.language}
                    currentURL={this.state.currentURL}
                    //Variables
                    showHeading={true}
                    // Methods
                    changeLanguage={this.changeLanguage}
                />
                <Validation
                    // State
                    language={this.state.language}
                    validationCode={this.state.validationCode}
                    callCode={this.state.callCode}
                    callCodeName={this.state.callCodeName}
                    sessionId={this.state.sessionId}
                    // Methods
                    generateValidationCode={this.generateValidationCode}
                    changeScreen={this.changeScreen}
                    changeCallCode={this.changeCallCode}
                    changeCallCodeName={this.changeCallCodeName}
                    changeMobile={this.changeMobile}
                />
                <Video language={this.state.language} />
            </div>
        );
        else if (this.state.screen === 'validationCode') return (
            <div className="col-xl-12">
                <Header
                    // State
                    language={this.state.language}
                    currentURL={this.state.currentURL}
                    //Variables
                    showHeading={true}
                    // Methods
                    changeLanguage={this.changeLanguage}
                />
                <ValidationCode
                    // State
                    language={this.state.language}
                    validationCode={this.state.validationCode} // for tests
                    mobile={this.state.mobile}
                    sessionId={this.state.sessionId}
                    // Methods
                    generateValidationCode={this.generateValidationCode}
                    validateCode={this.validateCode}
                    changeScreen={this.changeScreen}
                />
            </div>
        );
        else if (this.state.screen === 'customerDetails') return (
            <div className="col-xl-12">
                <Header
                    // State
                    language={this.state.language}
                    currentURL={this.state.currentURL}
                    //Variables
                    showHeading={true}
                    // Methods
                    changeLanguage={this.changeLanguage}
                />
                <CustomerDetails
                    // State
                    language={this.state.language}
                    mobile={this.state.mobile}
                    sessionId={this.state.sessionId}
                    // Methods
                    changeScreen={this.changeScreen}
                />
            </div>
        );
        else if (this.state.screen === 'success') return (
            <div className="col-xl-12">
                <Header
                    // State
                    language={this.state.language}
                    currentURL={this.state.currentURL}
                    //Variables
                    showHeading={true}
                    // Methods
                    changeLanguage={this.changeLanguage}
                />
                <Success
                    // State
                    language={this.state.language}
                />
            </div>
        );
    }
}

export default App;
